import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function DotGrid() {
  const [mousePos, setMousePos] = useState({
    x: 0,
    y: 0
  });
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      setMousePos({
        x: e.clientX,
        y: e.clientY
      });
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);
  return <div className="absolute inset-0 overflow-hidden pointer-events-none z-0" data-id="element-81">
      {/* Base dot pattern */}
      <div className="absolute inset-0 opacity-[0.15]" style={{
      backgroundImage: 'radial-gradient(#0A0A0A 1px, transparent 1px)',
      backgroundSize: '24px 24px'
    }} data-id="element-82" />

      {/* Interactive highlight mask */}
      <motion.div className="absolute inset-0 opacity-40" animate={{
      background: `radial-gradient(600px circle at ${mousePos.x}px ${mousePos.y}px, #ea580c, transparent 40%)`
    }} transition={{
      type: 'tween',
      ease: 'backOut',
      duration: 0.5
    }} style={{
      maskImage: 'radial-gradient(#0A0A0A 1px, transparent 1px)',
      WebkitMaskImage: 'radial-gradient(#0A0A0A 1px, transparent 1px)',
      maskSize: '24px 24px',
      WebkitMaskSize: '24px 24px'
    }} data-id="element-83" />

      {/* Fade out edges */}
      <div className="absolute inset-0 bg-gradient-to-b from-background/0 via-background/50 to-background" data-id="element-84" />
    </div>;
}